import { Colaborador } from "./Colaborador";

export default Colaborador